import MainComponent from "components/Main";
import PropTypes from 'prop-types';

import ButtonIcon from "components/ButtonIcon";

import './index.less';
import './themes/default.less';
import ButtonIconSelect from "components/ButtonIconSelect";

export default class ContentBlock extends MainComponent {
    static propTypes = {
        Ref: PropTypes.func,
        children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
        title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
        icon: PropTypes.object,
        icons: PropTypes.array,
        border: PropTypes.string,
        noTitle: PropTypes.bool,
        itemStyle: PropTypes.string,
    };
    static defaultProps = {
        Ref: null,
        children: null,
        title: "",
        icon: null,
        icons: [],
        border: "",
        noTitle: false,
        itemStyle: "",
    };

    getIcons(icons) {
        return (
            <div className="icons flex gap16">
                {icons.map((it, i) => {
                    return (it.items ?
                        <ButtonIconSelect key={i} {...it} /> :
                        <ButtonIcon key={i} {...it} />
                    );
                })}
            </div>
        );
    }

    render() {
        const { itemStyle, Ref, children, title, icon, icons, border, noTitle } = this.props;
        const dashed = border ? " dashed" : "";

        return (
            <div ref={Ref} className={`contentBlock flex col gap16 rad8 ${itemStyle} ${dashed}`}>
                {!noTitle && (
                    <div className="flex centerV gap8">
                        {title?.toLowerCase ? (
                            <div className="titleHeader flex1 text blockTitle">
                                {this.tr(title)}
                            </div>
                        ) : title}
                        {(icon || icons.length > 0) && this.getIcons(icon ? [icon] : icons)}
                    </div>
                )}
                {children}
            </div>
        );
    }
}
